import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AppService {
    static self: AppService;

    private reloadData$: Subject<boolean> = new Subject();

    constructor() {}

    reloadData() {
        this.reloadData$.next(true);
    }

    onReloadData() {
        return this.reloadData$.pipe(filter((val) => !!val));
    }
}
